<template>
  <div class="container-box">
    <iframe ref="iframeRef" class="frame" :src="frameUrl"></iframe>
    <el-tooltip content="Open in new tab" placement="right">
      <button class="eject-btn" @click="handleEject">
        <i class="fa fa-eject"></i>
      </button>
    </el-tooltip>
  </div>
</template>

<script>
const WORKFLOW_URL_BASE = process.env.VUE_APP_WORKFLOW_URL_BASE;

export default {
  components: {},
  name: "Flow",
  props: {
    msg: String,
    id: [String, Number, undefined],
  },
  data() {
    return {
      workflowUrlBase: WORKFLOW_URL_BASE,
      workflowId: this.id,
    };
  },
  computed: {
    frameUrl() {
      if (this.workflowId) {
        return `${this.workflowUrlBase}/workflow/${this.workflowId}`;
      } else {
        return this.workflowUrlBase;
      }
    },
  },
  methods: {
    handleEject() {
      // 优先用iframe真实url，否则用初始src
      const url = this.frameUrl;
      window.open(url, "_blank");
    },
    // 监听postMessage跨域同步id
    handleIframeMessage(event) {
      // 可加origin校验
      if (event.data && event.data.workflowId) {
        const id = event.data.workflowId;
        if (id && id !== String(this.workflowId)) {
          this.workflowId = id;
          this.$emit("update:id", id);
          const url = new URL(window.location.href);
          // 处理 hash 路径
          if (url.hash && url.hash.includes("/flow")) {
            // 解析 hash，查找 /flow
            const hashParts = url.hash.split("/");
            const flowIdx = hashParts.findIndex((p) => p === "flow");
            if (flowIdx !== -1) {
              // 判断下一个部分是不是数字（已有id）
              if (
                hashParts[flowIdx + 1] &&
                /^\d+$/.test(hashParts[flowIdx + 1])
              ) {
                hashParts[flowIdx + 1] = id;
              } else {
                hashParts.splice(flowIdx + 1, 0, id);
              }
              url.hash = hashParts.join("/");
            } else {
              // 没有 /flow，直接追加
              url.hash += (url.hash.endsWith("/") ? "" : "/") + "flow/" + id;
            }
          } else {
            // 没有 hash 或 hash 不含 /flow，直接追加
            if (url.hash) {
              url.hash += (url.hash.endsWith("/") ? "" : "/") + "flow/" + id;
            } else {
              url.hash = "#/flow/" + id;
            }
          }
          window.history.replaceState({}, "", url.toString());
        }
      }
    },
  },
  mounted() {
    window.addEventListener("message", this.handleIframeMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleIframeMessage);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container-box {
  position: absolute;
  width: 100%;
  height: 100%;
}

.eject-btn {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  font-size: 16px;
  border: none;
}

.frame {
  position: absolute;
  width: 100%;
  height: 100%;
  border: none;
}
</style>
